var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interface-Solid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-solid-multimedia-on-off-button"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.666,2.81152A1.25,1.25,0,0,0,17.834,5.169a11.5,11.5,0,1,1-7.668,0,1.25,1.25,0,0,0-.832-2.35743,14,14,0,1,0,9.332,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,14.28711a1.24991,1.24991,0,0,0,1.25-1.25V1.25a1.25,1.25,0,0,0-2.5,0V13.03711A1.24991,1.24991,0,0,0,14,14.28711Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exitIcon.7e291f70d4d2fd5eaeb446f656ef50bf.svg";
export { ForwardRef as ReactComponent };